/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts
 🗓️ Created: 2025-01-15
 🧩 Description:
    Default form data for Parking Lots.
────────────────────────────────────────────────────────────────*/

import type { ParkingLotFormState } from '../types';

export function createDefaultFormData(): ParkingLotFormState {
  return {
    name: '',
    extension: '',
    totalPositions: 10,
    parkingTime: 45,
    comebackTime: 30,
    findSlot: 'next',
    courtesyTone: 'caller',
    mohClass: 'default',
    returnToOriginator: true,
    announcePosition: true,
    callTransfer: false,
    callReparking: false,
    callHangup: false,
    record: false,
    announcementPath: '',
    timeoutModule: '',
    timeoutDestination: '',
    enabled: true,
    settings: {}
  };
}

